const categories = [
  {
    name: "องค์ประกอบสุขภาพทางกาย",
    key: "physicalHealth",
    indexes: [2, 3, 4, 10, 11, 12, 24],
    criterias: [
      {
        name: "คุณภาพชีวิตที่ดี",
        point: 27
      },
      {
        name: "คุณภาพชีวิตกลางๆ",
        point: 17
      },
      {
        name: "คุณภาพชีวิตที่ไม่ดี",
        point: 7
      }
    ]
  },
  {
    name: "องค์ประกอบด้านจิตใจ",
    key: "mentalHealth",
    indexes: [5, 6, 7, 8, 9, 23],
    criterias: [
      {
        name: "คุณภาพชีวิตที่ดี",
        point: 23
      },
      {
        name: "คุณภาพชีวิตกลางๆ",
        point: 15
      },
      {
        name: "คุณภาพชีวิตที่ไม่ดี",
        point: 6
      }
    ]
  },
  {
    name: "องค์ประกอบด้านสัมพันธภาพทางสังคม",
    key: "social",
    indexes: [13, 14, 25],
    criterias: [
      {
        name: "คุณภาพชีวิตที่ดี",
        point: 12
      },
      {
        name: "คุณภาพชีวิตกลางๆ",
        point: 8
      },
      {
        name: "คุณภาพชีวิตที่ไม่ดี",
        point: 3
      }
    ]
  },
  {
    name: "ด้านสิ่งแวดล้อม",
    key: "environment",
    indexes: [15, 16, 17, 18, 19, 20, 21, 22],
    criterias: [
      {
        name: "คุณภาพชีวิตที่ดี",
        point: 30
      },
      {
        name: "คุณภาพชีวิตกลางๆ",
        point: 19
      },
      {
        name: "คุณภาพชีวิตที่ไม่ดี",
        point: 8
      }
    ]
  },
  {
    name: "คุณภาพชีวิตโดยรวม",
    key: "overview",
    indexes: [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26
    ],
    criterias: [
      {
        name: "คุณภาพชีวิตที่ดี",
        point: 96
      },
      {
        name: "คุณภาพชีวิตกลางๆ",
        point: 61
      },
      {
        name: "คุณภาพชีวิตที่ไม่ดี",
        point: 26
      }
    ]
  }
];

const assessments = [
  {
    index: 1,
    question: "ท่านพอใจกับสุขภาพของท่านในตอนนี้เพียงใด",
    effect: "positive"
  },
  {
    index: 2,
    question:
      "การเจ็บปวดตามร่างกาย เช่น ปวดหัว ปวดท้อง ปวดตามตัว ทำให้ท่านไม่สามารถทำในสิ่งที่ต้องการมากน้อยเพียงใด",
    effect: "negative"
  },
  {
    index: 3,
    question:
      "ท่านมีกำลังเพียงพอที่จะทำสิ่งต่างๆ ในแต่ละวันไหม (ทั้งเรื่องงาน หรือการดำเนินชีวิตประจำวัน)",
    effect: "positive"
  },
  {
    index: 4,
    question: "ท่านพอใจกับการนอนหลับของท่านมากน้อยเพียงใด",
    effect: "positive"
  },
  {
    index: 5,
    question:
      "ท่านรู้สึกพึงพอใจในชีวิต (เช่น มีความสุข ความสงบ มีความหวัง) มากน้อยเพียงใด",
    effect: "positive"
  },
  {
    index: 6,
    question: "ท่านมีสมาธิในการทำงานต่างๆ ดีเพียงใด",
    effect: "positive"
  },
  {
    index: 7,
    question: "ท่านรู้สึกพึงพอใจในตนเองมากน้อยเพียงใด",
    effect: "positive"
  },
  {
    index: 8,
    question: "ท่านยอมรับรูปร่างหน้าตาของตัวเองได้ไหม",
    effect: "positive"
  },
  {
    index: 9,
    question:
      "ท่านมีความรู้สึกไม่ดี เช่น รู้สึกเหงา เศร้า หดหู่ สิ้นหวัง วิตกกังวล บ่อยแค่ไหน",
    effect: "negative"
  },
  {
    index: 10,
    question: "ท่านรู้สึกพอใจมากน้อยแค่ไหนที่สามารถทำอะไรๆ ผ่านไปได้ในแต่ละวัน",
    effect: "positive"
  },
  {
    index: 11,
    question:
      "ท่านจำเป็นต้องไปรับการรักษาพยาบาลมากน้อยเพียงใด เพื่อที่จะทำงานหรือมีชีวิตอยู่ไปได้ในแต่ละวัน",
    effect: "negative"
  },
  {
    index: 12,
    question: "ท่านพอใจกับความสามารถในการทำงานได้อย่างที่เคยทำมามากน้อยเพียงใด",
    effect: "positive"
  },
  {
    index: 13,
    question: "ท่านพอใจต่อการผูกมิตรหรือเข้ากับคนอื่น อย่างที่ผ่านมา แค่ไหน",
    effect: "positive"
  },
  {
    index: 14,
    question: "ท่านพอใจกับการช่วยเหลือที่เคยได้รับจากเพื่อนๆ แค่ไหน",
    effect: "positive"
  },
  {
    index: 15,
    question: "ท่านรู้สึกว่าชีวิตมีความมั่นคงปลอดภัยดีไหมในแต่ละวัน",
    effect: "positive"
  },
  {
    index: 16,
    question: "ท่านพอใจกับสภาพบ้านเรือนที่อยู่ตอนนี้มากน้อยเพียงใด",
    effect: "positive"
  },
  {
    index: 17,
    question: "ท่านมีเงินพอใช้จ่ายตามความจำเป็นมากน้อยเพียงใด",
    effect: "positive"
  },
  {
    index: 18,
    question: "ท่านพอใจที่จะสามารถไปใช้บริการสาธารณสุขได้ตามความจำเป็นเพียงใด",
    effect: "positive"
  },
  {
    index: 19,
    question:
      "ท่านได้รู้เรื่องราวข่าวสารที่จำเป็นในชีวิตแต่ละวัน มากน้อยเพียงใด",
    effect: "positive"
  },
  {
    index: 20,
    question: "ท่านมีโอกาสได้พักผ่อนคลายเครียดมากน้อยเพียงใด",
    effect: "positive"
  },
  {
    index: 21,
    question: "สภาพแวดล้อมดีต่อสุขภาพของท่าน มากน้อยเพียงใด",
    effect: "positive"
  },
  {
    index: 22,
    question:
      "ท่านพอใจกับการเดินทางไปไหนมาไหนของท่าน(การคมนาคม) มากน้อยเพียงใด",
    effect: "positive"
  },
  {
    index: 23,
    question: "ท่านรู้สึกว่าชีวิตท่านมีความหมายมากน้อยเพียงใด",
    effect: "positive"
  },
  {
    index: 24,
    question: "ท่านสามารถไปไหนมาไหนด้วยตนเองได้ดีเพียงใด",
    effect: "positive"
  },
  {
    index: 25,
    question: "ท่านพอใจในชีวิตทางเพศของท่านแค่ไหน",
    effect: "positive"
  },
  {
    index: 26,
    question: "ท่านคิดว่าท่านมีคุณภาพชีวิต อยู่ในระดับใด",
    effect: "positive"
  }
];

const choices = [
  {
    name: "ไม่เลย",
    point: 1
  },
  {
    name: "เล็กน้อย",
    point: 2
  },
  {
    name: "ปานกลาง",
    point: 3
  },
  {
    name: "มาก",
    point: 4
  },
  {
    name: "มากที่สุด",
    point: 5
  }
];

export { categories, assessments, choices };
